import React, {Component} from "react";
import Slider from "react-slick";
import getShortenedSubstring from '../utils/actions'

import arrow from "../images/arrow2.png";
import ellipse from "../images/ellipse.png";

class ClpTeacherBio extends Component {
  constructor() {
    super();
    this.state = {
      mediaCoverage: {
        list: [
          // {
          //   description: "An app that gives tutors the ease of managing a classroom at their fingertips, helping them invest more time in nurturing...",
          //   imageUrl: "https://d2sqt6igbl7quy.cloudfront.net/cams/mar21/Indian_Express_Logo_full-700x192.png",
          //   link: "https://indianexpress.com/article/lifestyle/art-and-culture/women-of-honour-destination-army-national-geographic-lt-gen-dr-madhuri-kanitkar-7219252/?fbclid=IwAR0VLJb0mK5474io4TUT5GOARKK0reB_v33TedR59syYKtPhUhOTYBONaW0",
          //   title: "Sapna Vardi Ka"
          // },
          // {
          //   description: "An app that gives tutors the ease of managing a classroom at their fingertips, helping them invest more time in nurturing...",
          //   imageUrl: "https://d2sqt6igbl7quy.cloudfront.net/cams/mar21/Indian_Express_Logo_full-700x192.png",
          //   link: "https://indianexpress.com/article/lifestyle/art-and-culture/women-of-honour-destination-army-national-geographic-lt-gen-dr-madhuri-kanitkar-7219252/?fbclid=IwAR0VLJb0mK5474io4TUT5GOARKK0reB_v33TedR59syYKtPhUhOTYBONaW0",
          //   title: "Sapna Vardi Ka"
          // },
          // {
          //   description: "An app that gives tutors the ease of managing a classroom at their fingertips, helping them invest more time in nurturing...",
          //   imageUrl: "https://d2sqt6igbl7quy.cloudfront.net/cams/mar21/Indian_Express_Logo_full-700x192.png",
          //   link: "https://indianexpress.com/article/lifestyle/art-and-culture/women-of-honour-destination-army-national-geographic-lt-gen-dr-madhuri-kanitkar-7219252/?fbclid=IwAR0VLJb0mK5474io4TUT5GOARKK0reB_v33TedR59syYKtPhUhOTYBONaW0",
          //   title: "Sapna Vardi Ka"
          // },
          // {
          //   description: "An app that gives tutors the ease of managing a classroom at their fingertips, helping them invest more time in nurturing...",
          //   imageUrl: "https://d2sqt6igbl7quy.cloudfront.net/cams/mar21/Indian_Express_Logo_full-700x192.png",
          //   link: "https://indianexpress.com/article/lifestyle/art-and-culture/women-of-honour-destination-army-national-geographic-lt-gen-dr-madhuri-kanitkar-7219252/?fbclid=IwAR0VLJb0mK5474io4TUT5GOARKK0reB_v33TedR59syYKtPhUhOTYBONaW0",
          //   title: "Sapna Vardi Ka"
          // },
          // {
          //   description: "An app that gives tutors the ease of managing a classroom at their fingertips, helping them invest more time in nurturing...",
          //   imageUrl: "https://d2sqt6igbl7quy.cloudfront.net/cams/mar21/Indian_Express_Logo_full-700x192.png",
          //   link: "https://indianexpress.com/article/lifestyle/art-and-culture/women-of-honour-destination-army-national-geographic-lt-gen-dr-madhuri-kanitkar-7219252/?fbclid=IwAR0VLJb0mK5474io4TUT5GOARKK0reB_v33TedR59syYKtPhUhOTYBONaW0",
          //   title: "Sapna Vardi Ka"
          // },
          // {
          //   description: "An app that gives tutors the ease of managing a classroom at their fingertips, helping them invest more time in nurturing...",
          //   imageUrl: "https://d2sqt6igbl7quy.cloudfront.net/cams/mar21/Indian_Express_Logo_full-700x192.png",
          //   link: "https://indianexpress.com/article/lifestyle/art-and-culture/women-of-honour-destination-army-national-geographic-lt-gen-dr-madhuri-kanitkar-7219252/?fbclid=IwAR0VLJb0mK5474io4TUT5GOARKK0reB_v33TedR59syYKtPhUhOTYBONaW0",
          //   title: "Sapna Vardi Ka"
          // },
        ],
        title: "Sapna Vardi Ka in media"
        
      },

      slideCount: 3,
    };
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.mediaCoverage !== this.props.mediaCoverage){
      this.setState(
        {
          mediaCoverage: nextProps.mediaCoverage
        },
        ()=>{
          if(this.state.mediaCoverage && this.state.mediaCoverage.list && this.state.mediaCoverage.list.length < 3){
            this.setState({slideCount: 1})
          }
        }
      )
    }
  }



  render() {
    const {mediaCoverage, slideCount} = this.state;

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: window.screen.availWidth < 700 ? 1 : slideCount,
      slidesToScroll: 1,
      arrows: false,
    };
    return ( 
      mediaCoverage && mediaCoverage.list && mediaCoverage.list.length > 0 ?
      <div className="ClpTeacherBio">
        <div className="ClpTeacherBio__Head">
          {this.props.title}
        </div>
        <div className="ClpTeacherBio__Content">
          <Slider {...settings} ref={(c) => (this.slider = c)}>
            {mediaCoverage && mediaCoverage.list && mediaCoverage.list.map((data, index) => {
              return (
                <div className="ClpTeacherBio__Content--Details" key={index}>
                  <div className="ClpTeacherBio__Content--Details__Container">
                    <div className="ClpTeacherBio__Content--Details__Container--Img">
                      <img
                        src={data.imageUrl}
                        alt=""
                      />
                    </div>
                    
                    <div className="ClpTeacherBio__Content--Details__Container--Title">
                      {/* {getShortenedSubstring(data.title, 25)} */}
                      {data.title}
                    </div>
                    <div className="ClpTeacherBio__Content--Details__Container--Para">
                      {data.description}
                    </div>
                    <div className="ClpTeacherBio__Content--Details__Container--ReadMore" onClick={()=>window.open(data.link, '_blank')}>
                      Read more
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
          {mediaCoverage && mediaCoverage.list && 
                    <div className="ClpTeacherBio__Content--ArrowDiv">
                    <img
                      className="ClpTeacherBio__Content--ArrowDiv__Right"
                      src={arrow}
                      alt=""
                      onClick={() => {
                        this.slider.slickPrev();
                      }}
                    />
                    <img
                      className="ClpTeacherBio__Content--ArrowDiv__Left"
                      src={arrow}
                      alt=""
                      onClick={() => {
                        this.slider.slickNext();
                      }}
                    />
                  </div>
          }

        </div>
      </div> : ""
    );
  }
}

export default ClpTeacherBio;
